export const getError = state => state.editEnvironment.get('error')
export const getIsSubmitting = state => state.editEnvironment.get('isSubmitting')
